/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsGraphsDto } from '../../models/submissions-graphs-dto';

export interface FactorFilteredSubmissionsGet$Params {
  fromDate?: string;
  toDate?: string;
  aggregationType?: string;
}

export function factorFilteredSubmissionsGet(http: HttpClient, rootUrl: string, params?: FactorFilteredSubmissionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphsDto>>> {
  const rb = new RequestBuilder(rootUrl, factorFilteredSubmissionsGet.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
    rb.query('aggregationType', params.aggregationType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubmissionsGraphsDto>>;
    })
  );
}

factorFilteredSubmissionsGet.PATH = '/Factor/filtered-submissions';
